// @ts-check

import {
  getPurchaseInvoiceEInvoiceAddress,
  getPurchaseInvoiceEmail
} from '@/api/settings'

/** @returns {PurchaseInvoiceModuleState} */
export const initPurchaseInvoiceState = () => ({
  purchaseInvoiceEmail: undefined,
  purchaseInvoiceFinvoice: undefined
})

/** @type {PurchaseInvoiceMutationTree} */
export const purchaseInvoiceMutations = {
  setEmail: (state, email) => {
    state.purchaseInvoiceEmail = email
  },
  setEInvoiceAddress: (state, address) => {
    if (address !== undefined) {
      state.purchaseInvoiceFinvoice = address
    } else {
      state.purchaseInvoiceFinvoice = null
    }
  }
}

/** @type {PurchaseInvoiceGetterTree} */
export const purchaseInvoiceGetters = {
  purchaseInvoiceEmail: ({ purchaseInvoiceEmail }) => purchaseInvoiceEmail,
  purchaseInvoiceEInvoiceAddress: (state) => {
    return state.purchaseInvoiceFinvoice
  }
}

/** @type {PurchaseInvoiceActionTree} */
export const purchaseInvoiceActions = {
  async fetchPurchaseInvoiceSettings({ dispatch }) {
    await dispatch('fetchPurchaseInvoiceEInvoiceAddress')
    await dispatch('fetchPurchaseInvoiceEmail')
  },
  async fetchPurchaseInvoiceEInvoiceAddress({ commit }) {
    const { data } = await getPurchaseInvoiceEInvoiceAddress()
    commit('setEInvoiceAddress', data)
  },
  async fetchPurchaseInvoiceEmail({ commit }) {
    const { emails } = await getPurchaseInvoiceEmail()
    if (emails.length > 0) {
      commit('setEmail', emails[0])
    } else {
      commit('setEmail', null)
    }
  }
}
